import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

type Kind = 'primary' | 'secondary' | 'tab';

const KIND_CLASSES: Record<Kind, string> = {
  primary:
    'bg-tea-700 text-white border-tea-700 hover:bg-tea-900 hover:border-tea-900',
  secondary: 'bg-card text-fg border-border hover:bg-tea-50',
  tab: 'rounded-none border-0 border-b-2 border-transparent bg-transparent px-3 py-2 text-muted hover:text-fg data-[active=true]:border-tea-700 data-[active=true]:text-fg',
};

type Props = JSX.ButtonHTMLAttributes<HTMLButtonElement> & {
  kind?: Kind;
  active?: boolean;
};

export function Button(props: Props) {
  const [local, rest] = splitProps(props, [
    'kind',
    'active',
    'class',
    'children',
  ]);
  return (
    <button
      type={rest.type ?? 'button'}
      data-active={local.active ? 'true' : undefined}
      class={classNames(
        'inline-flex items-center justify-center gap-2 rounded-md border px-3.5 py-2 text-sm font-medium transition-colors',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tea-500',
        KIND_CLASSES[local.kind ?? 'secondary'],
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </button>
  );
}
